/**
 * Sandbox demo auto-login hint (owner ask 2026-09-16).
 *
 * `GET /api/SandboxDemo/status` is anonymous and answers `autoSignIn: true` ONLY on the sandbox app, where
 * the server also signs every visitor in as the shared demo HR user at /Account/Login. Everywhere else it is
 * false and the landing page behaves exactly as before.
 *
 * Plain fetch on purpose: the shared request client carries the auth/401 interceptors (forceLogout), which
 * have no business running on the signed-out landing page. Any failure resolves to false.
 */
const serverUrl = process.env.SERVER_URL || window.location.origin;

export async function isSandboxAutoSignIn(timeoutMs = 5000): Promise<boolean> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    const res = await fetch(`${serverUrl}/api/SandboxDemo/status`, {
      credentials: 'omit',
      signal: controller.signal,
    });
    if (!res.ok) return false;
    const body = (await res.json()) as { payload?: { autoSignIn?: boolean } } | null;
    return body?.payload?.autoSignIn === true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
